/**
 *    Video with preview image
 */
(function ($) {
  Drupal.behaviors.videoWithPreview = {
    attach() {
      // click 'play' button
      $(document.body).on('click touchend', '.vb-media-play-button', function () {
        const $playButton = $(this);
        const $container = $playButton.closest('.vb-media-video-with-preview');
        const $carousel = $playButton.closest('.owl-carousel');
        // add 'active' class to container
        $container.addClass('active');
        // stop carousel autoplay
        if ($carousel.length) {
          // change option
          $carousel.data('owl.carousel').options.autoplay = false;
          // refresh carousel
          $carousel.trigger('refresh.owl.carousel');
        }
      });
    },
  };
}(jQuery));
// end of video-with-preview.js
